export default "__VITE_ASSET__CHbRdckQ__"